<template>

<div>

  <div class="card" >
    
  <div class="card-body">
      <div id="upload_progress">
            <div class="uploading-file pt-1" v-for="(file, i) in files" :id="'file_upload_' + file.uniqueIdentifier"
                :key="i" :class="{ 'text-success': file.success, 'text-danger': file.error }">
                <h6 class="fileuploadname m-0">{{ file.name }}</h6>
                <div class="progress" v-if="!file.success">
                    <div class="progress-bar" :style="{ width: file.progress+'%' }"></div>
                </div>
                <div class="upload-status" v-if="file.error">
                    {{ file.response.message }}
                </div>
                <div class="size">{{ formatFileSize(file.size) }}</div>
            </div>
        </div>

        <div id="file_drop_target">
                        <app-file-upload
                        class=""
                            :post-action="uploadUrl"
                            ref="upload"
                            v-model="files"
                            :multiple="true"
                            :drop="true"
                            :extensions="['mp3']"
                            @input-file="inputFile"
                            :headers="{'Authorization' : bearer }"
                            
                            :data="{'station' : stationId, 'playlistId': playlistId}"
                          >
                           <span class="mr-3 "> Drag and drop here for upload</span>
                           <button class="step-2 file-upload btn btn-info text-center mb-2"  v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button">Start upload <i class="fa fa-cloud" aria-hidden="true"></i></button>
                           <button class="file-upload btn btn-info text-center mb-2"  v-show="$refs.upload && $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">Stop upload</button>
                          </app-file-upload>
  
        </div>
  </div>
</div>
     <small class="ml-2"><strong>Note:</strong> ONLY mp3 files are acceptable</small>

 </div>     
   
</template>

<script>
import { formatFileSize } from '@/plugins/utils';
import AppFileUpload from "vue-upload-component";
import jwtService from "@/plugins/jwtService";

export default {
    name: 'FileUpload',
    props:['playlistId'],

    components: {
        AppFileUpload
    },

    data () {
        return {
            files: [],
            uploadUrl: process.env.VUE_APP_API_URL + 'admin/upload-files',
            bearer: "Bearer " + jwtService.getToken()
            

        };
    },

    computed: {
        validMimeTypesList () {
            if (this.validMimeTypes) {
                return this.validMimeTypes.join(', ');
            }

            return 'audio/mpeg';
        }
    },
    methods: {
        formatFileSize,

            // File Event
    inputFile(newFile, oldFile) {
      this.$Progress.start()

     

      this.$refs.upload.active = true;
      if (newFile != null && newFile.success == true) {
          this.$emit('relist')
        this.$Progress.finish()
        this.files = []
      }
          // Upload error
        if (newFile && oldFile && newFile.error !== oldFile.error) {

            console.log(newFile.error);
           this.$Progress.finish()

            // window.setTimeout(() => { 
            this.files = [newFile]
           
            // }, 10000);

        }

    
    }

    }
};
</script>

<style scoped>
 #file_drop_target {
    padding: 25px 0;
    border: 4px dashed #eee7e7;
    color: #5e5e5e;
    text-align: center;
}
.file-upload {
    cursor: pointer;
}
</style>
